// Placeholder overriden by theme
export default function CriteoFopAnalytics() {
  return null;
}
